
export enum ShipmentEventsCd {
	ALL_STATUSES = 'AllStatuses',
	DELAYS = 'Delays',
	MOVEMENT = 'Movement',
	PICKUP_OR_DELIVERY = 'PickupOrDelivery'}

